// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 31 ? "antd-icons" : chunkId) + "." + {"31":"a6856fd4","155":"973b279e","271":"2fea0238","632":"698d998c","748":"47bf5715"}[chunkId] + ".chunk.js";
};